<ng-container *ngIf="order">
  <div class="row">
    <div class="col-md-4  no-padding-right order-info-box">
      <app-card [title]="'admin.backoffice.order.information'|translate"
                [cardOptionBtn]="isEditableAfterCancel"
                [cardOptionBtnValue]="'global.edit'|translate"
                (outputButton)="editOrder()">
        <div class="row">
            <table class="table ms-3 col delivery-week-table">
              <tbody>
              <tr>
                <td class="pb-2">{{'doctrine.backoffice.order.number'|translate}}</td>
                <td class="pb-2">{{order.orderNo}}</td>
              </tr>
              <tr>
                <td class="pb-2">{{'doctrine.backoffice.order.date'|translate}}</td>
                <td class="pb-2">{{order.created|DateFormat }}</td>
              </tr>
              <tr>
                <td class="pb-2">{{'doctrine.backoffice.order.reference'|translate}}</td>
                <td class="pb-2">{{order.reference}}</td>
              </tr>
              <tr *ngIf="order.remark">
                <td class="pb-2">{{'admin.order.remark'|translate}}</td>
                <td class="pb-2">
                  {{order.remark.slice(0,20) + '...'}}
                  <a href="javascript:void(0)" (click)="orderRemarkModal.show()" style="margin-left: 30px; text-decoration: underline">{{'global.read_more' | translate}}</a>
                </td>
              </tr>
              <tr>
                <td class="pb-2">{{'doctrine.backoffice.order.ordered_by'|translate}}</td>
                <td class="pb-2">{{order.author.contact|titlecase}}</td>
              </tr>
              <tr>
                <td class="pb-2">{{'doctrine.backoffice.order.delivery_week'|translate}}</td>
                <td class="pb-2">
                  <ng-container>
                    {{order.expectedDeliveryWeek ? (order.expectedDeliveryWeek|WeekDateFormat) : ''}}
                    <span *ngIf="order.allowPartial && checkAllowPartialOrder(order)">({{this.getOrderAllowStatusTranslation(order.allowPartial)}})</span>
                  </ng-container>
                </td>
              </tr>
              <tr>
                <td class="pb-2">{{'doctrine.order.requested_delivery_week'|translate}}</td>
                <td class="pb-2">
                  <ng-container>
                    {{order.deliveryWeek ? (order.deliveryWeek|WeekDateFormat) : ''}}
                    <span *ngIf="order.allowPartial && checkAllowPartialOrder(order)">({{this.getOrderAllowStatusTranslation(order.allowPartial)}})</span>
                  </ng-container>
                </td>
              </tr>
              <tr>
                <td class="pb-2">{{'doctrine.backoffice.order.supplier'|translate}}</td>
                <td class="pb-2">{{order?.supplier?.companyName}}</td>
              </tr>
              <tr>
                <td class="pb-2">{{'doctrine.backoffice.order.status'|translate}}</td>
                <td class="pb-2">{{('doctrine.order.statuses.' + order.status)|translate}}</td>
              </tr>
              <!-- TODO: Uncomment this if you want enable service request feature -->
              <tr>
                <td class="pb-2">{{'global.remarks'|translate}}</td>
                <td class="pb-2">
                  <p *ngFor="let serviceRequestRemark of order.serviceRequestRemark" class="my-1"><a href="javascript:void(0);" (click)="remark = serviceRequestRemark;remarkModal.show();">{{serviceRequestRemark.subject}}</a></p>
                </td>
              </tr>
              </tbody>
            </table>
        </div>
      </app-card>
    </div>
    <div class="col-md-4 no-padding-right order-info-box">
      <app-card [title]="'admin.backoffice.order.company_information'|translate">
        <div class="row">
          <div class="col-md-5 infobox">
            <p>{{'doctrine.user.dealer_number'|translate}}</p>
            <p>{{'doctrine.user.companyName'|translate}}</p>
            <p>{{'doctrine.user.address'|translate}}</p>
            <p>{{'doctrine.user.email'|translate}}</p>
            <p>{{'doctrine.user.phone'|translate}}</p>
            <p *ngIf="order?.secondaryDeliveryWeek" class="pb-2">{{'doctrine.backoffice.order.secondary_delivery_week'|translate}}</p>
          </div>
          <div class="col-md-7 infobox">
            <p>{{order.user?.debtor}}</p>
            <p>{{order.user?.companyName}}</p>
            <p>{{order.user?.address}}</p>
            <p>{{order.user?.email}}</p>
            <p>{{order.user?.phone}}</p>
            <p *ngIf="order?.secondaryDeliveryWeek">
              {{order.secondaryDeliveryWeek ? (order.secondaryDeliveryWeek | WeekDateFormat) : ''}}
            </p>

          </div>
        </div>
      </app-card>
    </div>
    <div class="col-md-4 order-info-box">
      <app-card [title]="'admin.backoffice.order.delivery_information'|translate"
                [cardOptionBtn]="order?.customerDeliveryAddress?.fullName"
                [cardOptionBtnValue]="'global.edit'|translate"
                (outputButton)="openAddressModal()">
        <div class="row">
          <div class="col-md-5 infobox">
            <p>{{'doctrine.user.name'|translate}}</p>
            <p>{{'doctrine.user.address'|translate}}</p>
            <p>{{'doctrine.user.zipCode'|translate}}</p>
            <p>{{'doctrine.user.city'|translate}}</p>
            <p>{{'doctrine.user.country'|translate}}</p>
            <p>{{'doctrine.user.phone'|translate}}</p>
            <p>{{'doctrine.user.email'|translate}}</p>
          </div>
          <div *ngIf="order.customerDeliveryAddress" class="col-md-7 infobox">
            <p>{{order.customerDeliveryAddress?.fullName}}</p>
            <p>{{order.customerDeliveryAddress?.street + ' ' + order.customerDeliveryAddress?.houseNumber }}</p>
            <p>{{order.customerDeliveryAddress?.zipCode}}</p>
            <p>{{order.customerDeliveryAddress?.city}}</p>
            <p>{{order.customerDeliveryAddress?.country}}</p>
            <p>{{order.customerDeliveryAddress?.phoneNumber}}</p>
            <p>{{order.customerDeliveryAddress?.email}}</p>
          </div>
          <div *ngIf="!order.customerDeliveryAddress" class="col-md-7 infobox">
            <p>{{order.dealerDeliveryAddress?.companyName}}</p>
            <p>{{order.dealerDeliveryAddress?.address}}</p>
            <p>{{order.dealerDeliveryAddress?.postalCode}}</p>
            <p>{{order.dealerDeliveryAddress?.city}}</p>
            <p>{{order.dealerDeliveryAddress?.country?.name}}</p>
            <p>{{order.dealerDeliveryAddress?.phone}}</p>
            <p>{{order.dealerDeliveryAddress?.email}}</p>
          </div>
        </div>
      </app-card>
    </div>
  </div>
  <!--   Order-------------------------------------------------------------------->
  <div class="row">
    <div class="col-md-12">
      <app-card [title]="'admin.backoffice.order.title'|translate"
                [advanceButton]="true"
                [advancedButtons]="specialButton"
                (outputButtonAdvance)="calFunction($event)">
        <ng-template #orderTemplateRef let-order="order">
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive order-table">
                <table class="table table-order">
                  <thead>
                  <tr>
                    <th>{{'doctrine.backoffice.order.article'| translate}}</th>
                    <th>{{'doctrine.backoffice.order.article_number'| translate}}</th>
                    <th>{{'doctrine.backoffice.order.amount'| translate}}</th>
                    <th>{{'doctrine.backoffice.order.price'| translate}}</th>
                    <th>{{'doctrine.backoffice.order.total'| translate}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- Products, Fabrics, Packages, Properties--->
                  <ng-container *ngFor="let orderItem of order.orderItems;let i=index">
                    <ng-container *ngFor="let orderItemProduct of orderItem.orderItemProducts; let m = index;">
                      <tr class="after-divider">
                        <ng-container *ngIf="orderItemProduct.product">
                          <td>
                            <!--Products-->
                            <p class=""
                               *ngIf="orderItemProduct.product">{{orderItem.model.name}} {{(orderItem.style ? orderItem.style.name : '')}} {{orderItemProduct.product.name}} {{carpetSizeLabel(orderItemProduct.widthCm, orderItemProduct.lengthCm)}}</p>
                            <!--Fabrics-->
                            <p class="ms-3 "
                               *ngIf="orderItemProduct.orderItemProductFabricCollections.length > 0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])">
                              <ng-container *ngFor="let fabric of orderItemProduct.orderItemProductFabricCollections">
                                {{ 'doctrine.fabric.fabric'|translate}}:
                                {{(fabric.fabricCollection) ? fabric.fabricCollection.name + ',' : ''}}
                                <span *ngIf="fabric.fabricCollection.isCustom">
                                  {{fabric.fabricName+ ','}}
                                  {{fabric.fabricColorName }}
                                </span>
                                <span *ngIf="!fabric.fabricCollection.isCustom">
                                  {{(fabric.fabric) ? fabric.fabric.name + ',' : ''}}
                                  {{(fabric.fabricColor) ? fabric.fabricColor.name : '' }}
                                </span>
                              </ng-container>
                            </p>
                            <!--Packages-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <p class="ms-3 "
                                 *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0] && orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                {{orderItemProductPackage.package.name}}
                                <ng-container
                                  *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                  <span>{{orderItemProductPackageProduct.product.name}}</span>
                                </ng-container>
                              </p>
                            </ng-container>
                          </td>
                          <!-- article number-->
                          <td>
                            <p class="">{{orderItemProduct.product.number}}</p>
                            <p *ngIf="orderItemProduct.orderItemProductFabricCollections.length > 0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])" class="">&nbsp;</p>
                            <!--Packages-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <p *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0] && orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                <ng-container
                                  *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                  <span>&nbsp;</span>
                                </ng-container>
                              </p>
                            </ng-container>
                          </td>
                          <!--amount-->
                          <td>
                            <p *ngIf="orderItemProduct.product" class="">{{orderItemProduct.amount}}</p>
                            <p *ngIf="orderItemProduct.orderItemProductFabricCollections.length >0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])" class="">

                              {{orderItemProduct.orderItemProductFabricCollections[0]?.fabricCollection?.isCustom ? "" + recalculateFabricAmount(orderItemProduct.orderItemProductFabricCollections[0], orderItemProduct.selectedPerProductOption?.urbanOption, orderItemProduct.amount, orderItemProduct)  : orderItemProduct.orderItemProductFabricCollections[0].amount }}
                            </p>
                            <!--Packages-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <p *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0] && orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                <ng-container
                                  *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                  <span>{{orderItemProductPackageProduct.cost.amount}}</span>
                                </ng-container>
                              </p>
                            </ng-container>
                          </td>
                          <td>
                            <!-- Prices product-->
                            <p class="">{{(carpetUnitPrice(orderItemProduct))| BackofficeCurrency }}</p>
                            <!-- Prices fabric-->
                            <p
                              *ngIf="orderItemProduct.orderItemProductFabricCollections.length > 0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])"
                              class="">
                              <ng-container
                                *ngFor="let fabricCollection of orderItemProduct.orderItemProductFabricCollections">
                                {{ (isCustomerOrder ? fabricCollection.cost.customerPrice : fabricCollection.cost.dealerPrice) | BackofficeCurrency }}
                              </ng-container>
                            </p>
                            <!-- price ProductPackage-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <ng-container
                                *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                <p class=""
                                   *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                  {{ (isCustomerOrder ? orderItemProductPackageProduct.cost.customerPrice : orderItemProductPackageProduct.cost.dealerPrice) | BackofficeCurrency }}
                                </p>
                              </ng-container>
                            </ng-container>
                          </td>
                          <!-- total-->
                          <td>
                            <p class="">{{(carpetLineTotal(orderItemProduct))| BackofficeCurrency }}</p>
                            <p class=""
                               *ngIf="orderItemProduct.orderItemProductFabricCollections.length > 0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])">
                              <ng-container
                                *ngFor="let fabricCollection of orderItemProduct.orderItemProductFabricCollections">
                                {{ (isCustomerOrder ? fabricCollection.totalCost.totalCustomerCost : fabricCollection.totalCost.totalDealerPrice) | BackofficeCurrency }}
                              </ng-container>
                            </p>
                            <!--  ProductPackage-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <ng-container
                                *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                <p class=""
                                   *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                  {{ (isCustomerOrder ? orderItemProductPackageProduct.totalCost.totalCustomerCost : orderItemProductPackageProduct.totalCost.totalDealerPrice) | BackofficeCurrency }}
                                </p>
                              </ng-container>
                            </ng-container>
                          </td>
                        </ng-container>
                      </tr>
                      <!--Options: rendered by the recursive #optionCell template at the end of this file-->
                      <ng-container *ngFor="let option of calculateOptions(orderItem, orderItemProduct)">
                        <tr>
                          <td colspan="2">
                            <p class="ms-3">
                              <ng-container [ngTemplateOutlet]="optionCell"
                                            [ngTemplateOutletContext]="{$implicit: [option], col: 'name', parentCurrent: null, oip: orderItemProduct, level: 0}"></ng-container>
                            </p>
                          </td>
                          <td>
                            <p>
                              <ng-container [ngTemplateOutlet]="optionCell"
                                            [ngTemplateOutletContext]="{$implicit: [option], col: 'amount', parentCurrent: null, oip: orderItemProduct, level: 0}"></ng-container>
                            </p>
                          </td>
                          <td>
                            <p>
                              <ng-container [ngTemplateOutlet]="optionCell"
                                            [ngTemplateOutletContext]="{$implicit: [option], col: 'price', parentCurrent: null, oip: orderItemProduct, level: 0}"></ng-container>
                            </p>
                          </td>
                          <td>
                            <p>
                              <ng-container [ngTemplateOutlet]="optionCell"
                                            [ngTemplateOutletContext]="{$implicit: [option], col: 'total', parentCurrent: null, oip: orderItemProduct, level: 0}"></ng-container>
                            </p>
                          </td>
                        </tr>
                      </ng-container>
                      <tr *ngIf="m < orderItem.orderItemProducts.length - 1">
                        <td colspan="5" class="line-product">
                        </td>
                      </tr>
                    </ng-container>
                    <!--total price and divider-->
                    <tr class="divider" *ngIf="orderItem.orderItemProducts">
                      <td class="pt-3"><strong>{{'doctrine.backoffice.order.article_subtotal'| translate}}</strong></td>
                      <td class="pt-3"></td>
                      <td class="pt-3"></td>
                      <td class="pt-3"></td>
                      <td class="pt-3"><strong>{{orderItem.totalArticleDealerPrice | BackofficeCurrency}}</strong></td>
                    </tr>
                  </ng-container>
                  <!--custom row description-->
                  <ng-container *ngFor="let customRow of order.customRows; let i = index;">
                    <tr *ngIf="i == 0"><p></p></tr>
                    <tr [ngClass]="(i == (order.customRows.length - 1)) ? 'divider' : ''">
                      <td><p [ngClass]="(i == (order.customRows.length - 1)) ? 'mb-2' : ''">{{customRow.articleName}}</p></td>
                      <td></td>
                      <td><p
                        [ngClass]="(i == (order.customRows.length - 1)) ? 'mb-2' : ''">{{customRow.amount | number}}</p>
                      </td>
                      <td><p [ngClass]="(i == (order.customRows.length - 1)) ? 'mb-2' : ''">{{customRow.price}}</p></td>
                      <td class="">
                        <p [ngClass]="(i == (order.customRows.length - 1)) ? 'mb-2' : ''"><strong>{{(customRow.totalPrice) | BackofficeCurrency}}</strong></p>
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="order.transportationCost">
                    <tr><p></p></tr>
                    <tr class="divider">
                      <td><strong>{{'doctrine.order.transportation_costs'|translate}}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="after-divider">
                      <td><p>{{ order.user.invoiceDealer.transportationCostDescription }}</p></td>
                      <td></td>
                      <td><p>&nbsp;</p>
                      </td>
                      <td><p >&nbsp;</p></td>
                      <td class="">
                        <p><strong>{{(order.transportationCost) | BackofficeCurrency}}</strong></p>
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="order.customerDeliveryAddress?.fullName && !isCustomerOrder">
                    <tr><p></p></tr>
                    <tr class="divider">
                      <td><strong>{{'doctrine.order.delivery_cost_description'|translate}}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><p><strong>{{(order.dealerDeliveryCost) | BackofficeCurrency}}</strong></p></td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="isCustomerOrder && parseInt(order.deliveryCost) > 0">
                    <tr><p></p></tr>
                    <tr class="divider">
                      <td><strong>{{'doctrine.order.delivery_cost_description'|translate}}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><p><strong>{{(order.deliveryCost) | BackofficeCurrency}}</strong></p></td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="order.discount.applied > 0">
                    <tr><p></p></tr>
                    <tr class="divider">
                      <td><strong>{{'doctrine.order.discount'|translate}}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="after-divider">
                      <td><p>{{order.discount.description}}</p></td>
                      <td></td>
                      <td><p>&nbsp;</p>
                      </td>
                      <td><p >&nbsp;</p></td>
                      <td class="">
                        <p><strong>-{{(order.discount.applied) | BackofficeCurrency}}</strong></p>
                      </td>
                    </tr>
                  </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-md-3">
              <div class="table-responsive calculator-box">
                <table class="table table-sm">
                  <tr>
                    <td> {{'doctrine.backoffice.order.total_ex-vat'| translate}}</td>
                    <td class="">{{(isCustomerOrder ? order.totalCost.totalCustomerPrice : order.totalCost.totalDealerPrice) | BackofficeCurrency}}</td>
                  </tr>
                  <tr>
                    <td>{{'doctrine.backoffice.order.vat'| translate}}
                      <!--({{order.orderItems[0].orderItemProducts[0].product.vat.rate}}%)-->
                      ({{order.user.invoiceDealer['salesVatPercentage']}}%)
                    </td>
                    <td class="">{{(isCustomerOrder ? order.totalCost.totalCustomerVAT : order.totalCost.totalDealerVAT)| BackofficeCurrency}}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>
                        {{'doctrine.backoffice.order.total_price'| translate}}
                      </strong>
                    </td>
                    <td class="">
                      <strong>{{(isCustomerOrder ? order.totalCost.totalCustomerCost : order.totalCost.totalDealerCost)| BackofficeCurrency}}</strong>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template
          [ngTemplateOutlet]="orderTemplateRef"
          [ngTemplateOutletContext]="{ order: order }">
        </ng-template>
      </app-card>
    </div>
  </div>

  <!--  lastOrder-------------------------------------------------------------------->
  <ng-container *ngIf="order.lastOrder!==null">
    <div class="opacity">
      <ng-container *ngFor="let order of lastOrders">
        <div class="row">
          <div class="col-md-12">
            <app-card [title]="''+order.reference+''">
              <ng-template
                [ngTemplateOutlet]="orderTemplateRef"
                [ngTemplateOutletContext]="{ order: order }">
              </ng-template>
            </app-card>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <app-modal-basic #editOrderModal [dialogClass]="'modal-lg'">
    <div class="app-modal-header">
      <h4 class="modal-title">
        {{'admin.backoffice.order.information'| translate }}
      </h4>
      <button type="button" class="close basic-close" (click)="editOrderModal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <form novalidate #editOrderForm="ngForm">
        <div class="form-row row">
          <div class="form-group col-md-12">
            <label>{{"doctrine.backoffice.order.delivery_week" | translate}}   <span class="star">*</span></label>
            <div class="input-group" (clickOutside)="d.close()">
              <span *ngIf="delivery && delivery.year && delivery.month && delivery.day" class="clear-delivery-date" (click)="clearDeliveryDate()">
                <i class="fa fa-times"></i></span>
              <input class="form-control"
                     name="delivery"
                     ngbDatepicker
                     [dayTemplate]="customDay"
                     #d="ngbDatepicker"
                     [displayMonths]="1"
                     [navigation]="'select'"
                     [outsideDays]="'visible'"
                     [showWeekNumbers]="true"
                     [(ngModel)]="delivery"
                     [showWeekdays]="true"
                     [placement]="'bottom-right'"
              />
              <div class="input-group-append">
                <button class="btn btn-nopadding btn-outline-secondary calendar feather icon-calendar"
                        (click)="d.toggle()" type="button"></button>
              </div>
            </div>

          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <label>{{'doctrine.backoffice.order.status' | translate}} <span class="star">*</span></label>
            <ng-select [items]="statuses"
                       bindValue="key"
                       bindLabel="value"
                       [addTag]="false"
                       [hideSelected]="true"
                       [clearable]="false"
                       name="orderStatus"
                       [(ngModel)]="orderStatus">
            </ng-select>
            <span class="form-bar"></span>
          </div>
        </div>
      </form>
      <ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
        <span class="custom-day" [class.focused]="focused"
              [class.bg-primary]="isWeekSelected(date)" [class.hidden]="date.month !== currentMonth" [class.text-muted]="isDisabled(disabled, date, currentMonth)">
          {{ date.day }}
        </span>
      </ng-template>

    </div>
    <div class="app-modal-footer">
      <button type="button" class="btn btn-simple ripple me-4"
              (click)="editOrderModal.hide()">{{'global.cancel'|translate}}</button>
      <button type="submit" class="btn btn-primary ripple light" (click)="ConfirmEditOrderInformation(order)"
              [disabled]="!editOrderForm.valid">
        {{'global.actions.save'| translate}}
      </button>
    </div>
  </app-modal-basic>

  <app-modal-basic #addCustomRowModal [dialogClass]="'modal-lg'">

    <div class="app-modal-header">
      <h4 class="modal-title">
        {{'admin.backoffice.order.custom_row'| translate }}
      </h4>
      <button type="button" class="close basic-close" (click)="addCustomRowModal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <form novalidate #addCustomRowForm="ngForm">
        <div class="form-row row">
          <div class="form-group col-md-12">
            <input type="checkbox" class="border-checkbox" name="'hasCustomRow" [(ngModel)]="hasCustomRow">
            <label class="border-checkbox-label mb-0"
                   [for]="'hasCustomRow'">{{'doctrine.backoffice.order.custom_row'|translate}}</label>

            <button type="submit" class="btn btn-primary custom-btn-sm btn-sm ripple light float-right"
                    *ngIf="hasCustomRow"
                    (click)="addNewRow()">
              {{'doctrine.backoffice.order.add_custom_row' | translate}}
            </button>
          </div>
        </div>

        <div *ngIf="hasCustomRow">
          <ng-container *ngFor="let customRow of customRows; let i = index;">
            <div class="col-md-12 d-flex justify-content-between p-0">
              <p class="m-0"><b>{{'doctrine.backoffice.order.article'| translate}} {{i + 1}}</b></p>
              <button class="btn-link btn-remove-padding " type="button" *ngIf="i > 0"
                      (click)="removeCustomRow(i)">
                <i class="fa fa-trash fa-fw'"></i>
              </button>
            </div>
            <hr style="background-color: black">
            <div class="form-row row">
              <div class="form-group col">
                <label [for]="'articleName' + i">{{"doctrine.backoffice.order.article_name" | translate}}<span
                  class="star">*</span></label>
                <input required [name]="'articleName' + i"
                       [id]="'articleName' + i"
                       class="form-control"
                       #articleName="ngModel"
                       [(ngModel)]="customRow.articleName">
                <span class="form-bar"></span>
                <div class="messages text-danger"
                     *ngIf="articleName.invalid && articleName.dirty && articleName.errors?.required">
                  {{'errors.required'|translate}}
                </div>
              </div>
              <div class="form-group col">
                <label [for]="'amount' + i">{{"doctrine.backoffice.order.amount" | translate}}   <span
                  class="star">*</span></label>
                <input type="number" required [name]="'amount' + i"
                       [id]="'amount' + i"
                       min="1"
                       max="99999"
                       class="form-control"
                       pattern="\d+([.]\d(\d)?)?"
                       #amount="ngModel"
                       [(ngModel)]="customRow.amount">
                <span class="form-bar"></span>
                <div class="messages text-danger"
                     *ngIf="amount.invalid && amount.dirty && amount.errors?.required">
                  {{'errors.required'|translate}}
                </div>
                <div class="messages text-danger"
                     *ngIf="amount.invalid && amount.dirty && amount.errors?.pattern">
                  {{'errors.invalid'|translate}}
                </div>
              </div>
            </div>
            <p>{{'doctrine.backoffice.order.price'| translate}}</p>
            <hr>
            <div class="form-row row">
              <div class="form-group col-md-6">
                <label [for]="'price' + i">{{"doctrine.backoffice.order.price_reduction" | translate}} <span
                  class="star">*</span></label>
                <input required [name]="'price' + i"
                       type="number"
                       step="0.01"
                       min="0"
                       max="99999"
                       [id]="'price' + i"
                       class="form-control"
                       #price="ngModel"
                       [(ngModel)]="customRow.price">
                <span class="form-bar"></span>
                <div class="messages text-danger"
                     *ngIf="price.invalid && price.dirty && price.errors?.required">
                  {{'errors.required'|translate}}
                </div>
                <div class="messages text-danger"
                     *ngIf="price.invalid && price.dirty && price.errors?.pattern">
                  {{'errors.invalid'|translate}}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
    <div class="app-modal-footer">

      <button type="button" class="btn btn-simple ripple me-4"
              (click)="resetAddCustomRow(); addCustomRowModal.hide();">{{'global.cancel'|translate}}</button>

      <button type="submit" class="btn btn-primary ripple light" (click)="manageCustomRow()"
              [disabled]="(!editCustomRow && !hasCustomRow) || addCustomRowForm.invalid">
        {{(editCustomRow ? 'global.actions.save' : 'global.add')| translate}}
      </button>
    </div>
  </app-modal-basic>

  <app-modal-basic #cancelModal *ngIf="order!== undefined && order.orderItems[0]!== undefined ">
    <div class="app-modal-header">
      <h4 class="modal-title">{{ 'global.cancel_order' | translate}}</h4>
      <button type="button" class="close basic-close" (click)="cancelModal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <p>{{ 'global.cancel_order_body' | translate}}: <b [innerHTML]="order.orderNo"></b></p>
    </div>
    <div class="app-modal-footer">
      <button type="button" class="btn btn-simple ripple me-4"
              (click)="cancelModal.hide()">{{'global.cancel'|translate}}</button>
      <button type="button" class="btn btn-primary ripple light"
              (click)="cancelOrder()">{{'global.yes'|translate}}</button>
    </div>
  </app-modal-basic>

  <a #downloadLink href="" download style="display: none"></a>
  <app-modal-basic #splitModal [dialogClass]="'modal-lg'"
                   *ngIf="cloneOrder!== undefined && cloneOrder.orderItems[0] !== undefined">
    <div class="app-modal-header">
      <h4 class="modal-title">{{ 'doctrine.backoffice.order.split_order' | translate}}</h4>
      <button type="button" class="close basic-close" (click)="cancelSplit()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <p>{{'doctrine.backoffice.order.split_popup_description'| translate}}</p>
      <div class="table-responsive order-table">
        <table class="table" id="splitOrderTable">
          <thead>
          <tr class="header-row">
            <th>{{'doctrine.backoffice.order.article_number'| translate}}</th>
            <th>{{'doctrine.backoffice.order.article'| translate}}</th>
            <th>{{'doctrine.backoffice.order.amount'| translate}}</th>
          </tr>
          </thead>
          <tbody>
          <!-- Products, Fabrics, Packages, Properties--->
          <ng-container *ngFor="let orderItem of cloneOrder.orderItems;let i=index">
            <tr *ngFor="let orderItemProduct of orderItem.orderItemProducts; let m = index;">
              <ng-container *ngIf="orderItemProduct.product">
                <!-- article number-->
                <td>{{orderItemProduct.product.number}}</td>
                <td>
                  <!--Products-->
                  <span *ngIf="orderItem.model">{{orderItem.model.name}}</span>
                  <span *ngIf="orderItem.style"> {{orderItem.style.name}}</span>
                  <span *ngIf="orderItemProduct.product"> {{orderItemProduct.product.name}}</span>
                  <!--                &lt;!&ndash;Fabrics&ndash;&gt;-->
                  <!--                <span class="ms-3 mb-0" *ngIf="orderItemProduct.orderItemProductFabricCollections">-->
                  <!--                  <ng-container *ngFor="let fabric of orderItemProduct.orderItemProductFabricCollections">-->
                  <!--                    {{ 'doctrine.fabric.fabric'|translate}}:-->
                  <!--                    {{(fabric.fabricCollection) ? fabric.fabricCollection.name + ',' : ''}}-->
                  <!--                    {{(fabric.fabric) ? fabric.fabric.name + ',' : ''}}-->
                  <!--                    {{(fabric.fabricColor) ? fabric.fabricColor.name + ',' : '' }}-->
                  <!--                  </ng-container>-->
                  <!--                </span>-->
                  <!--Packages-->
                  <ng-container
                    *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                    <p class="ms-3 mb-0"
                       *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0] && orderItemProductPackage.orderItemProductPackageProducts[0].product">
                      {{orderItemProductPackage.package.name}}
                      <ng-container
                        *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                        <span>{{orderItemProductPackageProduct.product.name}}</span>
                      </ng-container>
                    </p>
                  </ng-container>
                </td>
                <!--amount-->
                <td width="10%">
                <span *ngIf="orderItemProduct.product">
                  <input class="form-control" type="number" [max]="getMaxAmount(orderItemProduct)" [min]="getMinAmount()"
                         [(ngModel)]="orderItemProduct.amount">
                </span>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
      <div class="form-group col">
        <label for='discountOn'>{{"doctrine.backoffice.order.discount_on" | translate}}</label>
        <ng-select class="select-box"
                   name='discountOn'
                   [items]="splitDiscountOptions"
                   [clearable]="false"
                   [(ngModel)]="splitDiscountOn"
                   bindValue="value" bindLabel="label">
        </ng-select>
      </div>
    </div>
    <div class="app-modal-footer">
      <button type="button" class="btn btn-simple ripple me-4"
              (click)="cancelSplit()">{{'global.cancel'|translate}}</button>
      <button type="button" class="btn btn-primary ripple light"
              (click)="splitOrder()"
              [disabled]="checkSplitIsDisabled()">{{'doctrine.backoffice.order.split'|translate}}</button>
    </div>
  </app-modal-basic>
</ng-container>

<app-modal-basic #notifyModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.warning' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="notifyModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p class="mb-0">{{ 'doctrine.order.change_status_notify' | translate}}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="notifyModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="editOrderInformation(order)">{{'global.continue'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #orderRemarkModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'admin.order.remark' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="orderRemarkModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <pre class="pre-box">{{ order && order.remark ? order.remark : "" }}</pre>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="orderRemarkModal.hide()">{{'global.close'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #remarkModal [hideFooter]="true">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.remarks' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="remarkModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <table class="table" *ngIf="remark">
      <tbody>
      <tr>
        <td class="pb-2">{{"doctrine.service_request.subject" | translate}}</td>
        <td class="pb-2">{{remark.subject}}</td>
      </tr>
      <tr>
        <td class="pb-2">{{"doctrine.service_request.phone" | translate}}</td>
        <td class="pb-2">{{remark.phone}}</td>
      </tr>
      <tr>
        <td class="pb-2">{{"doctrine.service_request.message" | translate}}</td>
        <td class="pb-2">{{remark.message}}</td>
      </tr>
      <tr>
        <td class="pb-2">{{"admin.service_request.files" | translate}}</td>
        <td class="pb-2">
          <a
            *ngFor="let file of remark.files"
            href="{{baseUrl + '/download?path=' + file.path + '&filename=' + file.filename}}"
            download="{{baseUrl + '/download?path=' + file.filename}}"
            class="btn btn-primary btn-file me-2"
          >
            <span class="fa {{getFontAwesomeIconFromMIME(file.mimeType)}}"></span>
          </a></td>
      </tr>
      </tbody>
    </table>
  </div>
</app-modal-basic>

<!-- Address confirmation-->
<app-modal-basic *ngIf="this.order?.customerDeliveryAddress" #addressModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.customer_address'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="addressModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div  class="app-modal-body" id="address-confirmation">
    <p class="model-text">{{ 'admin.customer_address.description'|translate}}</p>
    <div class="container">
      <form class="form-row row" #addressForm="ngForm" action="javascript:">
        <div class="form-group col-md-6">
          <label class="name">
               <span class="no-padding-y">
                  {{'doctrine.order.customer_address.full_name'|translate}}<span class="star">*</span>
               </span>
          </label>
          <div>
            <input type="text" class="form-control" name="addressFullName" #addressFullName="ngModel" [(ngModel)]="order.customerDeliveryAddress.fullName" autofocus required>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="name">
               <span class="no-padding-y">
                  {{'doctrine.order.customer_address.phone_number'|translate}}<span class="star">*</span>
               </span>
          </label>
          <div>
            <input type="text" class="form-control" name="addressPhoneNumber" #addressPhoneNumber="ngModel" [(ngModel)]="order.customerDeliveryAddress.phoneNumber" autofocus required>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="name">
               <span class="no-padding-y">
                  {{'doctrine.order.customer_address.email'|translate}}<span class="star">*</span>
               </span>
          </label>
          <div>
            <input type="text" class="form-control" name="addressEmail" #addressEmail="ngModel" [(ngModel)]="order.customerDeliveryAddress.email" autofocus required>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="name">
               <span class="no-padding-y">
                  {{'doctrine.order.customer_address.country'|translate}}<span class="star">*</span>
               </span>
          </label>
          <div>
            <input type="text" class="form-control" name="addressCountry" #addressCountry="ngModel" [(ngModel)]="order.customerDeliveryAddress.country" autofocus required>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="name">
               <span class="no-padding-y">
                  {{'doctrine.order.customer_address.city'|translate}}<span class="star">*</span>
               </span>
          </label>
          <div>
            <input type="text" class="form-control" name="addressCity" #addressCity="ngModel" [(ngModel)]="order.customerDeliveryAddress.city" autofocus required>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="name">
               <span class="no-padding-y">
                  {{'doctrine.order.customer_address.street'|translate}}<span class="star">*</span>
               </span>
          </label>
          <div>
            <input type="text" class="form-control" name="addressStreet" #addressStreet="ngModel" [(ngModel)]="order.customerDeliveryAddress.street" autofocus required>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="name">
               <span class="no-padding-y">
                  {{'doctrine.order.customer_address.house_number'|translate}}<span class="star">*</span>
               </span>
          </label>
          <div>
            <input type="text" class="form-control" name="addressHouseNumber" #addressHouseNumber="ngModel" [(ngModel)]="order.customerDeliveryAddress.houseNumber" autofocus required>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="name">
               <span class="no-padding-y">
                  {{'doctrine.order.customer_address.zip_code'|translate}}<span class="star">*</span>
               </span>
          </label>
          <div>
            <input type="text" class="form-control" name="addressZipCode" #addressZipCode="ngModel" [(ngModel)]="order.customerDeliveryAddress.zipCode" autofocus required>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple me-2 ripple"
            (click)="addressModal.hide()">{{ 'global.cancel' | translate }}</button>
    <button type="button" (click)="updateAddress()" [disabled]="!addressForm.valid" class="btn btn-primary ripple light">{{'global.update'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #addDiscountModal [dialogClass]="'modal-lg'">

  <div class="app-modal-header">
    <h4 class="modal-title">
      {{'admin.backoffice.order.discount.title'| translate }}
    </h4>
    <button type="button" class="close basic-close" (click)="addDiscountModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addDiscountForm="ngForm">
      <div class="form-row row">
        <div class="form-group col">
          <label for='discountType'>{{"admin.backoffice.order.discount.type" | translate}}</label>
          <ng-select class="select-box"
                     name='discountType'
                     [items]="discountTypeOptions"
                     [clearable]="false"
                     [(ngModel)]="discount.type"
                     (change)="changeDiscount($event)"
                     bindValue="value" bindLabel="label">
          </ng-select>
        </div>
        <div *ngIf="discount.type === Discount.TYPE_AMOUNT" class="form-group col">
          <label for='discountAmount'>{{"admin.backoffice.order.discount.amount" | translate}}</label>
          <input required name='discountAmount'
                 type="number"
                 step="0.01"
                 min="0"
                 max="9999999"
                 id='discountAmount'
                 class="form-control"
                 (ngModelChange)="castDiscount($event)"
                 [(ngModel)]="discount.amount">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="addDiscountForm.invalid && addDiscountForm.dirty && addDiscountForm.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
        <div *ngIf="discount.type === Discount.TYPE_PERCENTAGE" class="form-group col">
          <label for='discountPercent'>{{"admin.backoffice.order.discount.percent" | translate}}</label>
          <input required name='discountPercent'
                 type="number"
                 step="0.01"
                 min="0"
                 max="100"
                 id='discountPercent'
                 class="form-control"
                 (ngModelChange)="castDiscount($event)"
                 [(ngModel)]="discount.percentage">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="addDiscountForm.invalid && addDiscountForm.dirty && addDiscountForm.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
        <div class="form-group col">
          <div class="d-flex h-100 align-items-end">
            <span class="mb-1">≈ {{discount.type === Discount.TYPE_PERCENTAGE ? '€' : '%'}}{{discount.applied}}</span>
          </div>
        </div>
      </div>
      <div class="form-row row">
        <div class="form-group col">
          <label for="discount-description">{{'doctrine.backoffice.order.description' | translate}}</label>
          <textarea name="discount-description" id="discount-description" cols="30" rows="10" class="form-control"
                    #discountDescription="ngModel" [(ngModel)]="discount.description"></textarea>
          <div class="messages text-danger"
               *ngIf="discountDescription.invalid && discountDescription.dirty && discountDescription.errors.required">
            {{'errors.required'|translate}}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">

    <button type="button" class="btn btn-simple ripple me-4"
            (click)="addDiscountModal.hide()">{{'global.cancel' | translate}}</button>

    <button *ngIf="this.order && this.order.discount.applied > 0" type="button" class="btn btn-outline-secondary ripple me-4"
            (click)="removeDiscount()">{{'global.remove' | translate}}</button>

    <button type="button" class="btn btn-primary ripple light" (click)="manageDiscount()"
            [disabled]="addDiscountForm.invalid">
      {{'global.actions.save' | translate}}
    </button>
  </div>
</app-modal-basic>

<app-modal-basic #assignDealerModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.assign_quote' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="assignDealerModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addCreateCustomInvoiceForm="ngForm">
        <p>{{'admin.order.custom_invoice.modal.choose-dealer' | translate}}</p>
        <div class="form-group row">
          <div class="form-group form-default form-static-label col-12">
            <ng-select #dealerSelect="ngModel"
                 name="dealer"
                [items]="dealers"
                 [required]="true"
                 [(ngModel)]="selectedDealer"
                 bindLabel="companyName"
                 bindValue="id"
                 placeholder="{{ 'global.search'|translate }} {{ 'admin.dealer.show.delivery_dealers'|translate }}"
                 [clearable]="false"
                 autofocus
                 [typeahead]="dealersTypeahead">
                <ng-template ng-typetosearch-tmp>
                  <div class="ng-option disabled text-black-50">
                    {{ 'global.search'|translate }} {{ 'admin.dealer.show.delivery_dealers'|translate }}
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled text-black-50">
                    {{ 'doctrine.order.no_result_found_for'|translate }} {{ searchTerm }}
                  </div>
                </ng-template>
              </ng-select>
          </div>
        </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="assignDealerModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="assignDealer()">{{'global.actions.save'|translate}}</button>
  </div>
</app-modal-basic>

<!--
  Recursive renderer for an order item's options, mirroring the API's report template
  (templates/report/generateOptions.html.twig) so the screen and the PDF agree.

  An option whose `parent` equals the parent option's `current` value is appended inline
  (comma separated) on the same line; any other option starts its own indented line.
  Recursion is unbounded: the markup this replaced was unrolled to three fixed levels and
  looped grandchildren only under the indented branch, so an option nested below an inlined
  child (e.g. "Different legs: Yes, Metal legs, MB1: ...") was dropped from every column.

  Context: $implicit = options to render, col = 'name' | 'amount' | 'price' | 'total',
  parentCurrent = parent option's `current` (null at top level), oip = the OrderItemProduct,
  level = indentation depth in rem.
-->
<ng-template #optionCell let-options let-col="col" let-parentCurrent="parentCurrent" let-oip="oip"
             let-level="level">
  <ng-container *ngFor="let option of options">
    <span class="pt-3 mb-0" [class.d-block]="!isInlineOption(option, parentCurrent)"
          [style.margin-left.rem]="col === 'name' && !isInlineOption(option, parentCurrent) ? level : 0">
      <ng-container [ngSwitch]="col">
        <ng-container *ngSwitchCase="'name'">
          <ng-container *ngIf="isInlineOption(option, parentCurrent); else optionLabel">, {{option.current}}</ng-container>
          <ng-template #optionLabel>{{option.parent}}: {{option.current}}</ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'amount'">{{checkType(option) ? option.amount : ''}}</ng-container>
        <ng-container *ngSwitchCase="'price'">
          <ng-container *ngIf="checkType(option) && isCalculatable(oip)">{{(isCustomerOrder ? option.customerPrice : option.dealerPrice) | BackofficeCurrency}}</ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'total'">
          <ng-container *ngIf="checkType(option) && isCalculatable(oip)">{{(isCustomerOrder ? option.totalCustomerPrice : option.totalDealerPrice) | BackofficeCurrency}}</ng-container>
        </ng-container>
      </ng-container>

      <!--the option's fabric always gets its own line, and a spacer in the value columns
          so the lines stay aligned across all four columns-->
      <span class="pt-3 mb-0 d-block" *ngIf="option.fabric"
            [style.margin-left.rem]="col === 'name' ? level + 1 : 0">
        <ng-container *ngIf="col === 'name'; else fabricSpacer">
          {{'doctrine.fabric.fabric'|translate}}: {{option.fabricCollection}}, {{option.fabric}}, {{option.fabricColor}}
        </ng-container>
        <ng-template #fabricSpacer>&nbsp;</ng-template>
      </span>

      <ng-container *ngIf="option.children" [ngTemplateOutlet]="optionCell"
                    [ngTemplateOutletContext]="{$implicit: option.children, col: col, parentCurrent: option.current, oip: oip, level: isInlineOption(option, parentCurrent) ? level : level + 1}"></ng-container>
    </span>
  </ng-container>
</ng-template>
